module.exports = __webpack_public_path__ + "components/country-flag/static/gu-b5611c07362e16a0b72f671f26b70d6f.svg";